import React from 'react';
import PropTypes from 'prop-types';

import SessionStep from './SessionStep';
import AiSessionStep from './AiSessionStep';
import TalentAssessmentStep from './TalentAssessmentStep';
import CoachFeedbackStep from './FeedbackStep/CoachFeedback';
import ProgramFeedbackStep from './FeedbackStep/ProgramFeedback';

export default function Index({
  steps, programId, showStep, setShowStep,
}) {
  return (
    <div className="counting-icons-wrapper">
      {steps.filter((step) => step.step_type !== 'matrix').map((step) => (
        <div key={step.id} className="mb-4 program-step">
          {step.step_type === 'session' && (
            <SessionStep
              step={step}
              programId={programId}
              showStep={showStep}
              setShowStep={setShowStep}
            />
          )}

          {step.step_type === 'ai_session' && (
            <AiSessionStep
              step={step}
              programId={programId}
              showStep={showStep}
              setShowStep={setShowStep}
            />
          )}

          {step.step_type === 'first_cpa' && (
            <TalentAssessmentStep
              step={step}
              showStep={showStep}
              setShowStep={setShowStep}
            />
          )}

          {step.step_type === 'middle_cpa' && (
            <TalentAssessmentStep
              step={step}
              showStep={showStep}
              setShowStep={setShowStep}
            />
          )}

          {step.step_type === 'last_cpa' && (
            <TalentAssessmentStep
              step={step}
              showStep={showStep}
              setShowStep={setShowStep}
            />
          )}

          {step.step_type === 'coach_feedback' && (
            <CoachFeedbackStep
              step={step}
              programId={programId}
              showStep={showStep}
              setShowStep={setShowStep}
            />
          )}

          {step.step_type === 'program_feedback' && (
            <ProgramFeedbackStep
              step={step}
              programId={programId}
              showStep={showStep}
              setShowStep={setShowStep}
            />
          )}
        </div>
      ))}
    </div>
  );
}

Index.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.object).isRequired,
  programId: PropTypes.number.isRequired,
  showStep: PropTypes.bool.isRequired,
  setShowStep: PropTypes.func.isRequired,
};
